// Maps the canonical InventoryConfiguration#default_event_type value
// (DB-stored, synced to Papercut) to the user-facing label. Mirrors the
// formats used in Products (app/frontend/react/components/Product/types.ts).
export const FORMAT_OPTIONS = [
  { value: 'Buffet',       label: 'Buffet' },
  { value: 'MiniBuffet',   label: 'Mini Buffet' },
  { value: 'GatheringBox', label: 'Gathering Box' },
  { value: 'MealBox',      label: 'Meal Box' },
  { value: 'TreatBox',     label: 'Treat Box' },
];

export function getFormatLabel(value: string | null | undefined): string {
  return FORMAT_OPTIONS.find((o) => o.value === value)?.label ?? value ?? '';
}
